import Vue from 'vue'
import App from './App.vue'
// 按需引入 Ant Design Vue 组件
// 使用时直接 import { Button, Input } from 'ant-design-vue' 即可


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
